import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export function CtaLinksEditor({ value, onChange, hint, testid = "cta-links" }) {
  const links = value || [];
  const upd = (i, k, v) => onChange(links.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  return (
    <div className="space-y-2" data-testid={testid}>
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
      {links.map((l, i) => (
        <div key={i} className="grid grid-cols-[1fr_0.7fr_1.4fr_auto] gap-2" data-testid={`${testid}-row-${i}`}>
          <Input value={l.label} maxLength={60} onChange={(e) => upd(i, "label", e.target.value)} placeholder={i === 0 ? "Main button, e.g. Book An Intro Session" : "Button text"} data-testid={`${testid}-label-${i}`} />
          <Input value={l.location || ""} maxLength={60} onChange={(e) => upd(i, "location", e.target.value)} placeholder="Location (optional)" data-testid={`${testid}-location-${i}`} />
          <Input value={l.url} onChange={(e) => upd(i, "url", e.target.value.trim())} placeholder="https://…" data-testid={`${testid}-url-${i}`} />
          <button type="button" onClick={() => onChange(links.filter((_, j) => j !== i))} className="w-10 h-10 rounded-lg text-rose-600 hover:bg-rose-50 grid place-items-center" data-testid={`${testid}-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
      {links.length < 12 && <button type="button" onClick={() => onChange([...links, { label: "", url: "" }])} className="h-9 px-3 rounded-xl border text-xs font-semibold inline-flex items-center gap-1 bg-white hover:border-slate-400" data-testid={`${testid}-add`}><Plus className="w-3.5 h-3.5" />Add booking button</button>}
    </div>
  );
}
